import { render, staticRenderFns } from "./KlinePart.vue?vue&type=template&id=360bd65d&scoped=true&"
import script from "./KlinePart.vue?vue&type=script&lang=js&"
export * from "./KlinePart.vue?vue&type=script&lang=js&"
import style0 from "./KlinePart.vue?vue&type=style&index=0&id=360bd65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360bd65d",
  null
  
)

export default component.exports